import { createContext, useContext } from 'react'
import type { BrandKit } from './brand.types'
import { DEFAULT_BRAND } from './brandDetection'

export const BrandContext = createContext<BrandKit>(DEFAULT_BRAND)

/** Organization brand for the current host. */
export const useBrand = (): BrandKit => useContext(BrandContext)
